import { ConversationalSearchStorageManager, ConversationalSearchStorageManagerValues } from './storage-manager';

const storageManager = ConversationalSearchStorageManager.getInstance();

const getSessionStorageValue = (key: ConversationalSearchStorageManagerValues) => {
    return Boolean(storageManager.actionGetter(key));
};

const setSessionStorageValue = (key: ConversationalSearchStorageManagerValues, value?: string) => {
    storageManager.actionSetter(key, value);
};

const removeSessionStorageValue = (key: ConversationalSearchStorageManagerValues) => {
    storageManager.actionRemover(key);
};

export const getChatVisibilitySessionStorageValue = () => getSessionStorageValue(ConversationalSearchStorageManagerValues.CHAT_VISIBILITY);
export const setChatVisibilitySessionStorageValue = () => setSessionStorageValue(ConversationalSearchStorageManagerValues.CHAT_VISIBILITY);
export const removeChatVisibilitySessionStorageValue = () => removeSessionStorageValue(ConversationalSearchStorageManagerValues.CHAT_VISIBILITY);

export const getTermsAndConditionsSessionStorageValue = () => getSessionStorageValue(ConversationalSearchStorageManagerValues.TERMS_AND_CONDITIONS);
export const setTermsAndConditionsSessionStorageValue = () => setSessionStorageValue(ConversationalSearchStorageManagerValues.TERMS_AND_CONDITIONS);
export const removeTermsAndConditionsSessionStorageValue = () => removeSessionStorageValue(ConversationalSearchStorageManagerValues.TERMS_AND_CONDITIONS);

export const getUIDSessionStorageValue = () => storageManager.actionGetter(ConversationalSearchStorageManagerValues.UID);
export const setUIDSessionStorageValue = (value: string) => setSessionStorageValue(ConversationalSearchStorageManagerValues.UID, value);
export const removeUIDSessionStorageValue = () => removeSessionStorageValue(ConversationalSearchStorageManagerValues.UID);

export const getChatActionSessionStorageValue = () => getSessionStorageValue(ConversationalSearchStorageManagerValues.CHAT_ACTION);
export const setChatActionSessionStorageValue = () => setSessionStorageValue(ConversationalSearchStorageManagerValues.CHAT_ACTION);
export const removeChatActionSessionStorageValue = () => removeSessionStorageValue(ConversationalSearchStorageManagerValues.CHAT_ACTION);
